import create from 'zustand';
import {
  clearStoredAuthToken,
  readStoredAuthToken,
  writeStoredAuthToken,
} from 'lib/auth-token-storage';

export const useAuthStore = create((set) => ({
  token: typeof window !== 'undefined' ? readStoredAuthToken() : null,
  phone: null,
  user: null,
  workshopCustomer: null,

  setSession: (token, phone, user, workshopCustomer) => {
    writeStoredAuthToken(token);
    set({ token, phone, user, workshopCustomer });
  },

  setProfile: (user, workshopCustomer) => set({ user, workshopCustomer }),

  clearSession: () => {
    clearStoredAuthToken();
    set({
      token: null,
      phone: null,
      user: null,
      workshopCustomer: null,
    });
  },
}));

export function getDisplayName(user, workshopCustomer) {
  return (
    workshopCustomer?.name?.trim() ||
    [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim() ||
    'Workshop'
  );
}

export function getUserInitials(displayName) {
  return (
    displayName
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word[0]?.toUpperCase())
      .join('') || 'G'
  );
}
